import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CheckmarkCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.75 22.5C5.81294 22.5 1 17.6871 1 11.75C1 5.81294 5.81294 1 11.75 1C13.7068 1 15.5436 1.52351 17.1255 2.43862C17.7576 2.80422 18.7973 3.49578 19.7968 4.61155C18.9475 5.13511 18.1232 5.79427 17.3485 6.50607C16.0813 7.67028 14.8876 9.03067 13.865 10.3148C12.8405 11.6015 11.9754 12.8272 11.3667 13.7305L11.2789 13.8612C10.6849 13.0357 10.0687 12.4613 9.52591 12.0665C9.12071 11.7718 8.76199 11.5813 8.49231 11.4615C8.35755 11.4016 8.24507 11.3593 8.16014 11.3305C8.11767 11.3162 8.08206 11.3051 8.05396 11.2969C8.03991 11.2928 8.02773 11.2894 8.01751 11.2866L8.00365 11.2829L7.99783 11.2814L7.99521 11.2807L7.99397 11.2804C7.99397 11.2804 8.01751 11.2866 7.99277 11.2801C7.45698 11.1462 6.91404 11.4719 6.78009 12.0077C6.64733 12.5388 6.9662 13.0769 7.49357 13.2168C7.49701 13.2178 7.50528 13.2203 7.51806 13.2247C7.54837 13.235 7.60386 13.2552 7.68004 13.2891C7.83223 13.3567 8.06727 13.4787 8.34956 13.684C8.90935 14.0911 9.67848 14.8428 10.3558 16.1975C10.5187 16.5232 10.8457 16.7346 11.2095 16.7494C11.5733 16.7643 11.9169 16.5794 12.1057 16.2682L12.1081 16.2642L12.1188 16.2466L12.1637 16.174C12.2037 16.1094 12.2639 16.0132 12.3426 15.8894C12.5001 15.6417 12.7317 15.2839 13.0253 14.8481C13.6133 13.9754 14.4468 12.7949 15.4296 11.5607C16.4143 10.324 17.5368 9.04902 18.7016 7.97885C19.4788 7.26481 20.2497 6.66552 20.9888 6.22777C21.5472 7.16053 22.0162 8.27676 22.285 9.6008C22.4261 10.2959 22.5 11.0147 22.5 11.75C22.5 17.6871 17.6871 22.5 11.75 22.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CheckmarkCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CheckmarkCircleFilledIcon;
